import React from "react";
import { Header, Footer } from "../LandingPage/LandingPage";

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-grow container mx-auto px-4 py-12 max-w-4xl text-gray-800">
        <h1 className="text-3xl font-bold mb-6">Terms & Conditions</h1>

        <p className="mb-4">
          By accessing this website, you agree to be bound by the following
          terms and conditions, which may be updated from time to time.
        </p>

        <h2 className="text-xl font-semibold mb-2">Use of Website</h2>
        <ul className="list-disc list-inside mb-4 text-sm">
          <li>You agree not to use this site for any unlawful or prohibited activities.</li>
          <li>All content is the intellectual property of Gradiance and may not be reproduced without permission.</li>
        </ul>

        <h2 className="text-xl font-semibold mb-2">Product Information</h2>
        <p className="mb-4 text-sm">
          While we strive to ensure accurate product information, actual packaging and materials may vary. Please refer to product labels and datasheets.
        </p>

        <h2 className="text-xl font-semibold mb-2">Limitation of Liability</h2>
        <p className="mb-4 text-sm">
          Gradiance shall not be liable for any damages arising from the use or inability to use this website or its content.
        </p>

        <h2 className="text-xl font-semibold mb-2">Governing Law</h2>
        <p className="mb-4 text-sm">
          These terms are governed by the laws of India. Any disputes will be handled in the courts of Varanasi, Uttar Pradesh.
        </p>

        <p className="text-sm text-gray-600">
          Questions? Email us at{' '}
          <a
            href="mailto:gradiance.in@gmail.com"
            className="underline text-orange-600"
          >
            gradiance.in@gmail.com
          </a>
        </p>
      </main>
      <Footer />
    </div>
  );
};

export default TermsAndConditions;
